import React from 'react';
import { Redirect } from 'react-router-dom';

function CodeResearch() {
  window.open('http://medivi.herokuapp.com/code');
  return <Redirect to="/" />;
}

export default CodeResearch;
